import { Users, GraduationCap, Briefcase, DollarSign } from "lucide-react";

export const StatsSection = () => {
  const stats = [
    { number: "1000+", label: "Women Registered", icon: Users },
    { number: "500+", label: "Girls Learning", icon: GraduationCap },
    { number: "15+", label: "Trade Skills", icon: Briefcase },
    { number: "$2M+", label: "Loans Facilitated", icon: DollarSign },
  ];
  
  return (
    <section className="py-20 bg-gradient-to-br from-slate-800 to-slate-900" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center" data-testid={`stat-${index}`}>
              <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <stat.icon className="w-8 h-8 text-terracotta" />
              </div>
              <p className="text-4xl font-bold text-white mb-2">{stat.number}</p>
              <p className="text-slate-400">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
